import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import React, { useState } from "react";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import styles from "./styles.module.css";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import { criarContrato } from "../../services/api-contratos.service";
import Loading from "../../components/Loading";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";

const AnexoContrato = ({ open, setOpen, dadosUsuario, handleCloseAll }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfName, setPdfName] = useState("");
  const [fileKey, setFileKey] = useState(0);
  const [openVisualizador, setOpenVisualizador] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [right, setRight] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openSnackSucesso, setOpenSnackSucesso] = useState(false);
  const [openSnackErro, setOpenSnackErro] = useState(false);
  const [msg, setMsg] = useState("");

  const steps = [
    "Adicionar Contrato",
    "Adicionar Signatários",
    "Confirmar Dados",
  ];

  const handleCloseSnackSucesso = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackSucesso(false);
  };

  const handleCloseSnackErro = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackErro(false);
  };

  const handleClose = () => {
    setOpenVisualizador(false);
  };

  const handleCloseModal = () => {
    setOpen(false);
    URL.revokeObjectURL(pdfUrl);
    setPdfUrl(null);
    setPdfName("");
    setActiveStep(0);
    setRight([]);
  };

  const handleAvancar = () => {
    handleClose();
    setActiveStep(activeStep + 1);
  };

  const handleVoltar = () => {
    if (activeStep === 4) {
      setActiveStep(1);
    } else {
      setActiveStep(activeStep - 1);
    }
  };

  const handleEnviar = async () => {
    setLoading(true);
    handleAvancar();
    const base64 = await handleConvertToBase64(pdfUrl);
    const idUsuario =
      dadosUsuario.tipoUsuario === "Cliente"
        ? dadosUsuario.dados.id
        : dadosUsuario.dados.idUsuario;
    const body = {
      dadosUsuario: {
        id: idUsuario,
        nome: dadosUsuario.dados.nome,
        email: dadosUsuario.dados.email,
        tipoUsuario: dadosUsuario.tipoUsuario,
      },
      signatarios: right,
      file: base64,
      fileName: pdfName,
    };

    try {
      await criarContrato(body);
      await handleCloseAll();
      handleCloseModal();
      setMsg("Contrato enviado com sucesso!");
      setOpenSnackSucesso(true);
    } catch (error) {
      setActiveStep(2);
      setMsg("Ops! Temos um erro aqui. Contate o suporte.");
      setOpenSnackErro(true);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleConvertToBase64 = async (arquivo) => {
    return new Promise((resolve, reject) => {
      fetch(arquivo)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(blob);
        })
        .catch((error) => reject(error));
    });
  };

  return (
    <>
      <Dialog open={open} onClose={handleCloseModal} maxWidth="lg" fullWidth>
        <DialogTitle>
          <div className={styles.header}>
            <HistoryEduIcon />
            <h3>Contrato</h3>
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel
                    StepIconProps={{
                      sx: {
                        color: "#c9c9c9",
                        "&.Mui-active": {
                          color: "#18316e",
                        },
                        "&.Mui-completed": {
                          color: "#1d6e18",
                        },
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
        </DialogTitle>
        {loading ? (
          <Loading loading={loading} />
        ) : (
          <>
            {/* Step 1 */}
            {activeStep === 0 && (
              <Step1
                pdfUrl={pdfUrl}
                setPdfUrl={setPdfUrl}
                setFileKey={setFileKey}
                setOpenVisualizador={setOpenVisualizador}
                setPdfName={setPdfName}
                handleAvancar={handleAvancar}
                pdfName={pdfName}
                handleCloseModal={handleCloseModal}
              />
            )}

            {/* Step 2 */}
            {activeStep === 1 && (
              <Step2
                handleAvancar={handleAvancar}
                handleVoltar={handleVoltar}
                right={right}
                setRight={setRight}
              />
            )}

            {/* Step 3 */}
            {activeStep === 2 && (
              <Step3
                handleVoltar={handleVoltar}
                signatarios={right}
                pdfUrl={pdfUrl}
                fileKey={fileKey}
                handleEnviar={handleEnviar}
              />
            )}
          </>
        )}
      </Dialog>

      {/* Pré visualizador */}
      <Dialog
        open={openVisualizador}
        onClose={handleClose}
        fullWidth
        maxWidth="xl"
      >
        <div style={{ width: "100%", height: "90vh" }}>
          <iframe
            key={fileKey}
            src={pdfUrl}
            title="Pré-visualização do PDF"
            style={{ width: "100%", height: "100%", border: "none" }}
          />
        </div>
        <div style={{ padding: "1rem" }}>
          <DialogActions className={styles.container_btn}>
            <Button
              className={styles.btn_close}
              onClick={handleClose}
              variant="outlined"
            >
              Fechar
            </Button>
            <Button
              className={pdfUrl ? styles.btn_avancar : ""}
              onClick={handleAvancar}
              variant="contained"
              disabled={!pdfUrl}
            >
              Avançar
            </Button>
          </DialogActions>
        </div>
      </Dialog>
      <MensagemSucesso
        open={openSnackSucesso}
        msg={msg}
        handleClose={handleCloseSnackSucesso}
      />
      <MensagemErro
        open={openSnackErro}
        msg={msg}
        handleClose={handleCloseSnackErro}
      />
    </>
  );
};

export default AnexoContrato;
